import { Environment } from './types';
import { createGlobalStore } from '../store/utils';

export const environment = createGlobalStore({ ...window.__ENVIRONMENT__ } as Environment, 'environment');

window.environment = environment;
